var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutlineClipped83X83 = function SvgOutlineClipped83X83(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 47 113"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83.513,
    height: 83.513,
    x: 58.116,
    y: -2.586,
    stroke: "#E5E5E5",
    rx: 9,
    transform: "rotate(46.625 58.116 -2.586)"
  })));
};
export default SvgOutlineClipped83X83;